// src/components/SelectedChips.jsx  —  ohapotato v2026.10.36
import React from 'react';

export default function SelectedChips({ selectedList, onRemove, onClear }) {
  const count = selectedList.length;

  if (count === 0) {
    return (
      <div style={styles.emptyWrap}>
        <p style={styles.empty}>Tap ingredients above to add them here</p>
      </div>
    );
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.chips}>
        {selectedList.map(ing => (
          <div key={ing.id} style={styles.chip}>
            <span>{ing.emoji}</span>
            <span style={styles.chipLabel}>{ing.label}</span>
            <button style={styles.remove} onClick={() => onRemove(ing.id)} aria-label={`Remove ${ing.label}`}>×</button>
          </div>
        ))}
      </div>
      <div style={styles.footer}>
        <span style={styles.countLabel}>
          {count} ingredient{count !== 1 ? 's' : ''} selected
          {count < 2 && <span style={styles.needMore}> — add 1 more</span>}
          {count >= 2 && <span style={styles.readyTip}> ✓ ready to search</span>}
        </span>
        {count > 1 && (
          <button style={styles.clearAll} onClick={onClear}>Clear all</button>
        )}
      </div>
    </div>
  );
}

const styles = {
  emptyWrap: {
    padding: '10px 0 4px',
  },
  empty: {
    fontSize: '12.5px',
    color: 'var(--text-muted)',
    fontStyle: 'italic',
    fontFamily: 'var(--font-body)',
    margin: 0,
  },
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px 4px 7px',
    background: 'var(--chip-bg)',
    color: 'var(--chip-text)',
    borderRadius: 'var(--radius-pill)',
    fontSize: '12px',
    fontWeight: '500',
    animation: 'popIn 0.18s ease',
    transition: 'background 0.3s ease, color 0.3s ease',
  },
  chipLabel: { fontSize: '12px' },
  remove: {
    background: 'none',
    border: 'none',
    color: 'inherit',
    opacity: 0.55,
    cursor: 'pointer',
    fontSize: '15px',
    padding: 0,
    lineHeight: '1',
    fontFamily: 'inherit',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  countLabel: {
    fontSize: '11.5px',
    color: 'var(--text-muted)',
    fontFamily: 'var(--font-body)',
  },
  needMore: {
    color: 'var(--accent-orange)',
    fontWeight: '600',
  },
  readyTip: {
    color: 'var(--accent-green)',
    fontWeight: '600',
  },
  clearAll: {
    background: 'none',
    border: 'none',
    color: 'var(--text-muted)',
    fontSize: '11.5px',
    fontWeight: '500',
    cursor: 'pointer',
    fontFamily: 'var(--font-body)',
    padding: 0,
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    whiteSpace: 'nowrap',
  },
};
